import { render, staticRenderFns } from "./pastRespondents.vue?vue&type=template&id=01d7b873&"
import script from "./pastRespondents.vue?vue&type=script&lang=js&"
export * from "./pastRespondents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports